import http from '@/utils/http';
import { IAccessCodeLoginResponse } from '@home/types/login';

export const login: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/auth/login',
    method: 'post',
    data: payload,
    errorHandler: true,
    noAuth: true,
    setAuth: true,
  }) as Promise<any>;
};

export async function getEmailCode(params: any) {
  return http('/api/v1/auth/getEmailCode', {
    errorHandler: true,
    method: 'post',
    data: params,
    noAuth: true,
  });
}

export async function verifyEmailCode(params: any) {
  return http('/api/v1/auth/verifyEmailCode', {
    errorHandler: true,
    method: 'post',
    data: params,
    noAuth: true,
    setAuth: true,
    headers: {
      Language: params?.lang,
    },
  });
}

export async function sendResetEmail(params: any) {
  // return http('/api/v1/auth/getUpdateUrl', {
  return http('/api/v1/auth/v2/getUpdateUrl', {
    errorHandler: true,
    method: 'post',
    data: params,
    noAuth: true,
  });
}
export async function updatePassword(params: any) {
  return http('/api/v1/auth/updatePassword', {
    errorHandler: true,
    method: 'post',
    data: params,
    noAuth: true,
  });
}
export async function register(params: any) {
  return http('/api/v1/auth/register', {
    errorHandler: true,
    method: 'post',
    data: params,
    noAuth: true,
  });
}
export async function getOrganization() {
  return http('/api/v1/auth/menu/group', {
    errorHandler: true,
    method: 'get',
    noAuth: true,
  }) as Promise<string[]>;
}

export const getSSOList: () => Promise<any> = () => {
  return http({
    url: '/api/v1/auth/oidc',
    method: 'get',
    errorHandler: true,
    noAuth: true,
  }) as Promise<any>;
};

// global oa登录
export const globalOALogin: () => Promise<any> = () => {
  return http({
    url: 'api/v1/auth/saml/login',
    method: 'get',
    errorHandler: true,
    noAuth: true,
    setAuth: true,
  }) as Promise<any>;
};

// 获取岗位
export const getOccupation = ()=> http(`/api/v1/auth/user/occupation`, {
  method: 'GET',
});

/**
 * 激活访问码并登录
 * @param code - 访问码
 * @returns 登录响应，包含 token
 */
export const activateAccessCode = (code: string): Promise<IAccessCodeLoginResponse> => {
  return http({
    url: '/api/v1/common/access-code/login',
    method: 'post',
    data: { code },
    errorHandler: true,
    noAuth: true,
    setAuth: false, // 改为 false，因为后端不在响应头返回 token
    rawData: true, // 返回完整响应数据（包含 code/msg/data）
  }) as Promise<IAccessCodeLoginResponse>;
};